import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { initStockUnsubscribeAction } from 'reducks/stock/actions'

const unsubscribeStocks = () => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const unsubscribe = getState().stock.unsubscribe
    unsubscribe()
    dispatch(initStockUnsubscribeAction())
  }
}

export default unsubscribeStocks
